import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { useQuery } from '@apollo/react-hooks'

import { UNPROTECTED_ROUTES } from 'constants/unprotectedRoutes'

import { useHoneybadger } from './Honeybadger'
import currentUserQuery from './query.graphql'

class BaseErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    didCatch: PropTypes.func.isRequired,
    renderError: PropTypes.func.isRequired,
  }

  state = {
    error: null,
    errorOccurred: false,
  }

  static getDerivedStateFromError(error) {
    return { errorOccurred: true, error }
  }

  componentDidCatch(error, info) {
    this.props.didCatch(error, info)
  }

  render() {
    const { children, renderError } = this.props
    const { errorOccurred, error } = this.state

    return errorOccurred ? renderError(error) : children
  }
}

export function ErrorBoundary({ children, didCatch, renderError }) {
  const honeybadger = useHoneybadger()
  const { data } = useQuery(currentUserQuery, {
    skip: UNPROTECTED_ROUTES.includes(window.location.pathname),
  })

  return (
    <BaseErrorBoundary
      renderError={renderError}
      didCatch={(error, info) => {
        honeybadger.notify(error, {
          context: info,
          params: {
            user_id: data?.id,
            user_email: data?.email,
            institution_title: data?.primaryInstitution?.title,
            role: data?.primaryRole,
          },
        })
        didCatch && didCatch(error, info)
      }}
    >
      {children}
    </BaseErrorBoundary>
  )
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  didCatch: PropTypes.func,
  renderError: PropTypes.func.isRequired,
}
